import { observer } from 'mobx-react';
import moment from 'moment';
import { Button } from 'primereact/button';
import { Column, ColumnProps } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Paginator } from 'primereact/paginator';
import React, { RefObject } from 'react';

import qs from 'qs';
import { DataSource } from '../../models/DataSource';
import { DataTableFilterService } from '../../services/DataTableFilterService';
import { MonitoringRestService } from '../../services/MonitoringRestService';
import { DependencyContainer } from '../../utils/DependencyInjection';
import { AwbDetailModalComponent } from '../awb/AwbDetailModalComponent';
import { Dialog } from 'primereact/dialog';
import { Growl } from 'primereact/growl';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { IWeightDiffFilterContainerValue, WeightDifferenceFilterContainer } from './WeightDifferenceFilterContainer';
import { Flex } from 'reflexbox';
export interface IWeightDiffContainerQuery {
  filters: IWeightDiffFilterContainerValue;
}

@observer
export class WeightDifferenceContainer extends React.Component<any, any> {
  dataTableFilterService = DependencyContainer.get(DataTableFilterService);
  monitoringRestService = DependencyContainer.get(MonitoringRestService);
  refFilter: RefObject<WeightDifferenceFilterContainer> = React.createRef();

  weighDifferenceData;
  growl;
  dataSource = new DataSource<any>();
  refAwbDetailModal: RefObject<AwbDetailModalComponent> = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      exportExcelLoading: false,
      showExportDialog: false,
      showWeightDifferenceStatusDialog: false,
      weightDiffStatus: 'uncheck', // for dialog update state
      weightDiffNotes: '', // for dialog update state
      changeStatusId: null,
      changeStatusProcess: false,
    }
  }

  componentDidMount() {
    const queryFilter = (this.props.history.location.search)
      ? qs.parse(
        this.props.history.location.search.substr(1),
      ) as any
      : {} as any;

    // if (queryFilter && queryFilter.filters) {
    //   if (this.refFilter.current) {
    //     const newFilters = this.refFilter.current.setFormValues(queryFilter.filters);
        this.loadData();
    //   }
    // }

    this.dataSource.onPageChange.subscribe(() => {
      this.loadData();
    });
  }

  loadData(filterParams: any = null) {
    const pagingParams = { limit: this.dataSource.rows, page: this.dataSource.page };
    const fParams = (filterParams)
      ? Object.assign({}, filterParams, pagingParams)
      : Object.assign({}, this.refFilter.current!.formValues, pagingParams);

    this.dataSource.loading = true;
    this.monitoringRestService
      .post('weight-difference', fParams)
      .subscribe(
        response => {
          this.weighDifferenceData = response;
          this.populateDataSource();
        },
        null,
        () => {
          this.dataSource.loading = false;
        },
      );
  }

  populateDataSource() {
    if (this.weighDifferenceData.data && this.weighDifferenceData.data.length) {
      this.dataSource.setData(this.weighDifferenceData.data);
      this.dataSource.setTotal(this.weighDifferenceData.count);
    } else {
      this.dataSource.setData([]);
      this.dataSource.setTotal(0);
    }
  }

  columnDateFormat = (rowData, column: ColumnProps) => {
    return (
      (rowData[column.field!] != null) ? moment(new Date(rowData[column.field!])).utc().format('DD-MM-YYYY') : ''
    );
  }

  colomnAction = (rowData : any) => {
    const data = {...rowData}
    return (
      <button
        className="btn btn-sm btn-primary"
        onClick={() => {
          this.setState({changeStatusId: data._id, weightDiffStatus: data.weightDiffStatus, weightDiffNotes: data.weightDiffNotes, showWeightDifferenceStatusDialog: true})
        }}
      >
        Ubah Status
      </button>
    )
  }

  render() {
    const footer = 'Total data: ' + this.dataSource.total;
    const stateOptions = [
      {value: 'uncheck', label: 'Uncheck'},
      {value: 'oncheck', label: 'On check'},
      {value: 'solved', label: 'Solved'},
    ];

    return (
      <div>
        <AwbDetailModalComponent ref={this.refAwbDetailModal} />

        <Dialog header="Ubah Status Selisih" visible={this.state.showWeightDifferenceStatusDialog} style={{width: '40vw'}} modal={true} onHide={() => this.setState({showWeightDifferenceStatusDialog: false})}>
          <label>Status</label><br/>
          <Dropdown
            options={stateOptions}
            value={this.state.weightDiffStatus}
            onChange={option => {
              this.setState({weightDiffStatus: option.value})
            }}
          />
          <br/><br/>
          <label>Catatan</label><br/>
          <InputTextarea rows={5} style={{width: '100%'}} value={this.state.weightDiffNotes} onChange={(e) => this.setState({weightDiffNotes: (e.target as HTMLTextAreaElement).value})} />
          <br/><br/>
          <Button label="Batal" onClick={() => this.setState({weightDiffStatus: '', weightDiffNotes: '', changeStatusId: null, showWeightDifferenceStatusDialog: false}) } className="p-button-danger" style={{marginRight: '20px'}} />

          <Button
            label="Simpan Perubahan"
            disabled={this.state.changeStatusProcess}
            onClick={async () => {
              this.setState({changeStatusProcess: true});
              const id = this.state.changeStatusId;
              if (id) {
                const dataset = {weightDiffStatus: this.state.weightDiffStatus, weightDiffNotes: this.state.weightDiffNotes};

                await this.monitoringRestService
                  .put('weight-difference/'+id, dataset)
                  .subscribe(
                    response => {
                      if (response) {
                        this.loadData();
                      }
                    },
                    null,
                    () => {
                      this.setState({showWeightDifferenceStatusDialog: false, changeStatusProcess: false, changeStatusId: null, weightDiffStatus: 'uncheck', weightDiffNotes: ''});
                      let msg = { severity: 'success', summary: 'Success Message', detail: 'Update status berhasil' };
                      this.growl.show(msg);
                    },
                  );
              } else {
                this.setState({changeStatusProcess: false});
                let msg = { severity: 'error', summary: 'Error Message', detail: 'Gagal update status, id tidak tersedia' };
                this.growl.show(msg);
              }
              
            }} />
        </Dialog>

        <Growl ref={el=> this.growl = el} style={{marginTop: '75px'}}/>

        <Growl ref={el=> this.growl = el} style={{marginTop: '75px'}}/>

        <Flex className="card w-full">
          <Flex className="w-full" column>
            <WeightDifferenceFilterContainer ref={this.refFilter} />
            <br/>
            <Flex>
              <Button
                className="p-button-success mr-2"
                label="Tampilkan"
                onClick={
                  () => {
                    this.dataSource.setPage(1);
                  }
                }
              />
            </Flex>
          </Flex>
        </Flex>

        <div className="card">
          <DataTable
            emptyMessage={'Tidak ada data untuk ditampilkan.'}
            scrollable={true}
            scrollHeight="550px"
            style={{ width: '100%' }}
            className="mt-4"
            value={this.dataSource.data}
            loading={this.dataSource.loading}
            footer={footer}>

            <Column
              field=""
              header="#"
              sortable={false}
              style={{ width: '120px' }}
              body={row => this.colomnAction(row)}
            />
            <Column
              field="awbNumber"
              header="No Resi"
              sortable={false}
              style={{ width: '130px' }}
            />
            <Column
              field="tglTransaksi"
              header="Tgl. Transaksi"
              body={this.columnDateFormat}
              sortable={false}
              style={{ width: '145px' }}
            />
            <Column
              field="partnerName"
              header="Partner"
              sortable={false}
              style={{ width: '200px' }}
            />
            <Column
              field="shipperName"
              header="Merchant"
              sortable={false}
              style={{ width: '200px' }}
            />
            <Column
              field=""
              header="Foto"
              sortable={false}
              style={{ width: '120px' }}
              body={row => {
                return <div className="text-center"> {
                  row.awbNumber ?
                  (
                    <a target='_blank' href={"/monitor/trackingNote/showImage/" + row.awbNumber}>
                      Lihat Foto
                    </a>
                  ) : 
                  '-'
                }</div>
              }}
            />
            <Column
              field="totalWeight"
              header="Berat API"
              sortable={false}
              style={{ width: '120px', textAlign: 'center' }}
            />
            <Column
              field="berat"
              header="Berat"
              sortable={false}
              style={{ width: '120px', textAlign: 'center' }}
            />
            <Column
              field="beratAsli"
              header="Berat Asli"
              sortable={false}
              style={{ width: '120px', textAlign: 'center' }}
            />
            <Column
              field="weightDiff"
              header="Selisih Berat"
              sortable={false}
              style={{ width: '120px', textAlign: 'center' }}
            />
            <Column
              field=""
              header="Status Selisih"
              sortable={false}
              className="text-center"
              style={{ width: '120px' }}
              body={row => {
                switch (row.weightDiffStatus) {
                  case 'uncheck': 
                    return <span className="badge badge-pill badge-danger">Uncheck</span> 

                  case 'oncheck': 
                    return <span className="badge badge-pill badge-warning">On check</span>  

                  case 'solved': 
                    return <span className="badge badge-pill badge-success">Solved</span>  
                
                  default:
                    return ''
                }
              }}
            />
            <Column
              field="weightDiffNotes"
              header="Catatan Berat"
              sortable={false}
              style={{ width: '180px' }}
            />
          </DataTable>

          <Paginator
            totalRecords={this.dataSource.total}
            first={this.dataSource.offset}
            rows={this.dataSource.rows}
            rowsPerPageOptions={this.dataSource.rowsOptions}
            onPageChange={e => this.dataSource.fromPageState(e)}
          />
        </div>
      </div>
    );
  }
}
